// Newest widget home version — see src/Views/Home/homeVersions.ts for the
// version → component map. Bumping this ships a new version; it does NOT
// change what any existing project renders (see FALLBACK_HOME_VERSION).
export const LATEST_HOME_VERSION = 4;

// What a project renders when it has no version configured. Deliberately NOT
// tied to LATEST_HOME_VERSION: a new home version is opted into in the
// dashboard, never rolled out by deploying the widget.
//
// This is the pre-v4 behaviour restored exactly (App.tsx before 17dca66:
// `v === 3 ? AgentHome : v === 2 ? HomePage : ClassicHome`, TabBar
// `v === 3 && "v3"`, WidgetMenu `v === 3` for pills) — absent AND unknown
// values all landed on the classic home. Resolving them to the latest instead
// is what silently moved every project that never picked a version onto the
// v4 agentic home, AI hero composer included (#141887).
export const FALLBACK_HOME_VERSION = 1;

// THE rule for turning a raw `config.v` into the version that actually
// renders: a version we ship renders as configured, anything else (absent,
// unknown) renders the fallback. Every version-conditional branch must agree
// on this — while one of them defaulted differently, the v4 home drew each
// menu item twice, once as a hero pill and once as a content button.
//
// Components ask the Config store's getHomeVersion() rather than calling this
// directly, so `config.v` is never read raw.
export const resolveHomeVersion = (v?: number): number =>
  v && v >= 1 && v <= LATEST_HOME_VERSION ? v : FALLBACK_HOME_VERSION;
